import { useState } from "react";
import { characters } from "@/mocks/manga";

const filters = ["全部", "主角", "系统", "配角"];

const categoryColor: Record<string, string> = {
  "主角": "bg-primary-500",
  "系统": "bg-accent-500",
  "配角": "bg-secondary-500",
};

export default function Characters() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? characters : characters.filter((c) => c.category === active);

  return (
    <section id="characters" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-500">
              <span className="h-px w-8 bg-primary-400" aria-hidden="true"></span>
              角色介绍
            </p>
            <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              恋爱辅助器 <span className="text-primary-600">男主女主</span> 与全角色
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-700">
              从元气女主苏念安、高冷男主陆之遥，到毒舌系统阿柒与温柔学长、理论闺蜜，
              一文读懂每位角色的性格关键词与成长线。
            </p>
          </div>

          <div className="flex items-center gap-1 rounded-full bg-background-200/70 p-1">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setActive(f)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  active === f
                    ? "bg-background-50 text-primary-700 shadow-sm"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((c) => (
            <article
              key={c.id}
              className="group overflow-hidden rounded-2xl bg-background-50 p-4 transition-transform duration-300 hover:-translate-y-1 md:p-5"
            >
              <div className="relative overflow-hidden rounded-xl">
                <img
                  src={c.image}
                  alt={`恋爱辅助器漫画角色${c.name}人物介绍`}
                  className="aspect-[3/3.6] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 rounded-full px-3 py-1 text-xs font-semibold text-white ${categoryColor[c.category]}`}
                >
                  {c.category}
                </span>
              </div>

              <div className="mt-4 flex items-start justify-between gap-3">
                <div>
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
                  <p className="mt-0.5 text-xs text-primary-600">{c.role}</p>
                </div>
                <span className="whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                  {c.tag}
                </span>
              </div>

              <p className="mt-3 font-display text-sm italic leading-relaxed text-accent-700">
                「{c.quote}」
              </p>
              <p className="mt-2 text-sm leading-7 text-foreground-700">{c.intro}</p>

              <div className="mt-4 space-y-2.5">
                {c.statLabel.map((label, i) => (
                  <div key={label} className="flex items-center gap-3">
                    <span className="w-20 shrink-0 text-xs text-foreground-600">{label}</span>
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                      <div
                        className={`h-full rounded-full ${categoryColor[c.category]}`}
                        style={{ width: `${c.statValue[i]}%` }}
                      ></div>
                    </div>
                    <span className="w-8 text-right text-xs font-semibold text-foreground-700">
                      {c.statValue[i]}
                    </span>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}